import {useParams} from 'react-router'
import {PageLayout} from '~/components'
import {User} from '@eitje/api'
import {ShowUserHeader} from './show_user_header'
import {UserBasicTable, UserOrganisationBasicTable} from '~/components/basic_table/instances'
import {ResourceFetcher} from '~/services/resource_fetcher'

export const ShowUser = () => {
	const {id} = useParams()
	const user = User.useFind(id, {joins: ['organisations', 'environments']})

	if (_.isEmpty(user)) return <ResourceFetcher id={id} kind="users" />

	return (
		<PageLayout width={800} name="show_user" direction="vertical" gap={4} padding="- - 24 -" floating unsetPagePadding>
			<ShowUserHeader name={user.full_name} />
			<UserBasicTable data={user} />
			{user.organisations.map(organisation => (
				<UserOrganisationBasicTable organisation={organisation} user={user} />
			))}
		</PageLayout>
	)
}
